
import { Component, Vue } from 'vue-property-decorator'
import CupomService from '@/services/CupomService'
import { namespace } from 'vuex-class'

const PedidoStore = namespace('Pedido')

interface CupomDisponivel {
  id: number
  descricao: string
  cupom_code: string
  tipo: 'VALOR' | 'PORCENTAGEM'
  valor: number | null
  porcentagem: number | null
  valor_minimo_pedido: number | null
}

@Component
export default class CupomDesconto extends Vue {
  @PedidoStore.Getter
  private getPedido!: any

  @PedidoStore.Action
  private aplicarCupomDesconto!: (cupomDesconto: any[]) => Promise<any>

  private cupomDesconto = ''
  private descontoAplicado = ''
  private dialogCupons = false
  private cuponsDisponiveis: CupomDisponivel[] = []
  private loading = false

  formatarValorCupom(cupom: CupomDisponivel): string {
    if (cupom.tipo === 'VALOR') {
      return cupom.valor != null
        ? `R$ ${this.formatarValor(cupom.valor)} de desconto`
        : 'Valor não definido'
    } else {
      return cupom.porcentagem != null
        ? `${cupom.porcentagem}% de desconto`
        : 'Porcentagem não definida'
    }
  }

  formatarValor(valor: number | string | null): string {
    if (valor == null) return '0,00'
    const numeroValor = typeof valor === 'string' ? parseFloat(valor) : valor
    return isNaN(numeroValor)
      ? '0,00'
      : numeroValor.toFixed(2).replace('.', ',')
  }

  selecionarCupom(cupomCode: string) {
    const cupomSelecionado = this.cuponsDisponiveis.find(
      c => c.cupom_code === cupomCode
    )
    if (cupomSelecionado) {
      this.cupomDesconto = cupomCode
      this.dialogCupons = false
      this.aplicarCupom()
    }
  }

  async aplicarCupom() {
    try {
      this.loading = true
      const cupons = this.getPedido.cupomDesconto || [];
      await this.aplicarCupomDesconto([...cupons, { cupom_code: this.cupomDesconto }])
    } catch (error) {
      console.error('Erro ao aplicar cupom:', error)
    } finally {
      this.loading = false
    }
  }

  async abrirDialogCupons() {
    this.dialogCupons = true
    await this.buscarCupons()
  }

  async buscarCupons() {
    try {
      const cupons = await CupomService.getCuponsByCliente()
      this.cuponsDisponiveis = cupons
    } catch (error) {
      console.error('Erro ao buscar cupons:', error)
      this.cuponsDisponiveis = []
    }
  }
}
